module.exports = __webpack_public_path__ + "img/sleeve_opening.9c0deb1a.png";